import React, { memo } from 'react';
import classnames from 'classnames';
import './ParticipantsGridToggle.scss';
const ParticipantsGridToggle = ({ isOpen, clickHandle }) => {
    const rootClassNames = classnames({
        'ml-grid-toggle': true,
        'ml-grid-toggle--open': isOpen,
    });
    return (<button className={rootClassNames} onClick={clickHandle} type="button"/>);
};
export default memo(ParticipantsGridToggle);
